import axios from 'axios';
import { ClientSupplier } from '@timesheet/schemas';
import { getApiBaseUrl } from '../lib/api-base-url';

const API_URL = getApiBaseUrl();

export const clientSupplierService = {
  getAll: async (): Promise<ClientSupplier[]> => {
    const response = await axios.get(`${API_URL}/client-supplier`);
    return response.data;
  },

  getById: async (id: number): Promise<ClientSupplier> => {
    const response = await axios.get(`${API_URL}/client-supplier/${id}`);
    return response.data;
  },

  create: async (data: Omit<ClientSupplier, 'id' | 'tenantId' | 'isActive'>): Promise<ClientSupplier> => {
    const response = await axios.post(`${API_URL}/client-supplier`, data);
    return response.data;
  },

  update: async (id: number, data: Partial<ClientSupplier>): Promise<ClientSupplier> => {
    const response = await axios.patch(`${API_URL}/client-supplier/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`${API_URL}/client-supplier/${id}`);
  },

  import: async (file: File): Promise<{ total: number; created: number; errors: string[] }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_URL}/client-supplier/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  previewImport: async (file: File): Promise<{
    total: number;
    created: number;
    valid: number;
    errors: string[];
    rows: Array<{
      rowNumber: number;
      valid: boolean;
      error?: string;
      name?: string;
      type?: string;
      vatNumber?: string;
      email?: string;
      pec?: string;
      address?: string;
    }>;
  }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_URL}/client-supplier/import/preview`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  downloadImportTemplate: async (): Promise<Blob> => {
    const response = await axios.get(`${API_URL}/client-supplier/import/template`, {
      responseType: 'arraybuffer',
    });
    return new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
  },
};
